module.exports = __webpack_public_path__ + "img/40403744.8b96da44.png";